/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum UserStatus {
    ONBOARDING = 'ONBOARDING',
    ACTIVE = 'ACTIVE',
    ACTIVE_HIDDEN = 'ACTIVE_HIDDEN',
    BANNED = 'BANNED',
}
